var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfriendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_27639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.10922 7.30999C9.12922 7.30999 10.7692 5.66999 10.7692 3.64999C10.7692 1.62999 9.12922 -0.0100098 7.10922 -0.0100098C5.08922 -0.0100098 3.44922 1.62999 3.44922 3.64999C3.44922 5.66999 5.08922 7.30999 7.10922 7.30999ZM4.64922 3.65999C4.64922 2.29999 5.74922 1.19999 7.10922 1.19999C8.46922 1.19999 9.56922 2.29999 9.56922 3.65999C9.56922 5.01999 8.46922 6.11999 7.10922 6.11999C5.74922 6.11999 4.64922 5.01999 4.64922 3.65999Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40145 13.11H1.43145C1.35145 13.11 1.29145 13.08 1.24145 13.03C1.21145 12.99 1.19145 12.95 1.20145 12.9C1.25145 12.48 1.33145 12.06 1.44145 11.64C1.96145 9.74 4.04145 9.06999 5.67145 9.06999H8.56145C9.23145 9.06999 9.92145 9.2 10.5314 9.42C10.9414 9.12 11.3914 8.89 11.8714 8.72C10.9414 8.17 9.80145 7.87 8.56145 7.87H5.67145C2.98145 7.87 0.861446 9.23 0.291446 11.32C0.161446 11.8 0.0714458 12.29 0.0114458 12.77C-0.0285542 13.16 0.0914458 13.53 0.351446 13.83C0.621446 14.13 1.01145 14.3 1.43145 14.3H8.40145C8.38144 14.09 8.34145 13.89 8.34145 13.68C8.34145 13.48 8.38144 13.3 8.40145 13.11Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6286 9.35999C11.2486 9.35999 9.30859 11.3 9.30859 13.68C9.30859 16.06 11.2486 18 13.6286 18C16.0086 18 17.9486 16.06 17.9486 13.68C17.9486 11.3 16.0086 9.35999 13.6286 9.35999ZM16.8486 13.68C16.8486 15.45 15.4086 16.9 13.6286 16.9C11.8486 16.9 10.4086 15.46 10.4086 13.68C10.4086 11.9 11.8486 10.46 13.6286 10.46C15.4086 10.46 16.8486 11.9 16.8486 13.68Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6984 13.13C11.3884 13.13 11.1484 13.38 11.1484 13.68C11.1484 13.98 11.3984 14.23 11.6984 14.23H15.5584C15.8684 14.23 16.1084 13.98 16.1084 13.68C16.1084 13.38 15.8584 13.13 15.5584 13.13H11.6984Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_27639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.95,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfriendIcon);
export default __webpack_public_path__ + "static/media/unfriendIcon.a2e4ea13249caa5261f1eaf62080f3de.svg";
export { ForwardRef as ReactComponent };